<template>
  <div :class="[classObj, isErp? 'is-erp-show' : '']" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside"/>
    <sidebar class="sidebar-container"/>
    <div :class="{hasTagsView:needTagsView}" class="main-container">
      <div :class="{'fixed-header':fixedHeader}" :style="isErp? styleData: ''">
        <navbar/>
        <tags-view v-if="needTagsView" data-key="visitedViews"/>
      </div>
      <app-main>
        <div :class="{'fixed-header':fixedHeader}" :style="!isErp? styleData: ''" v-if="erpVisitedViews.length > 0 && showHead">
          <tags-view key="erp" data-key="erpVisitedViews" v-if="needTagsView"/>
        </div>
      </app-main>
    </div>
  </div>
</template>

<script>
import {AppMain, Navbar, Sidebar, TagsView} from './components'
import ResizeMixin from './mixin/ResizeHandler'
import {mapState} from 'vuex'

import {isClient} from "@/utils/tool";

export default {
  name: 'LayoutErp',
  components: {
    AppMain,
    Navbar,
    Sidebar,
    TagsView
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader,
      erpVisitedViews: state => state.tagsView.erpVisitedViews
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    },
    isErp() {
      return isClient()
    },
    showHead() {
      const { meta: { erp } } = this.$route || { meta: { erp: false } }
      return erp || false
    }
  },
  watch: {
    showHead(val) {
      console.log(val)
    }
  },
  data() {
    return {
      styleData: {
        display: 'none'
      }
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', {withoutAnimation: false})
    }
  },
  created() {
  }
}
</script>

<style lang="scss">
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px)
}

.mobile .fixed-header {
  width: 100%;
}

.is-erp-show {
  .app-main {
    height: calc(100vh) !important;
  }


  .m-grid {
    height: calc(100vh - 10px) !important;
  }
}

</style>
